<template>
  <v-container  v-if="!isMobile">
    <div class="table-container">
      <table v-if="loadingTable">
        <thead>
          <tr>
            <th v-for="item in dailyHeader" :key="item.type">{{ item.label  }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="item in dailyHeader" :key="item.type">
              <div class="skeleton"></div>
            </td>
          </tr>
        </tbody>
      </table>
      
      <div v-else class="table-gird" id="time__table">
        <!-- 헤더 -->
        <div class="table-row table-header">
          <div class="table-cell date" :style="{ gridRow: `span 2` }" @click="sortByDate">날짜</div>
          <div
            v-for="item in dailyHeader"
            :key="item.type"
            class="table-cell"
            :style="{ gridColumn: `span 3` }"
          >
            {{ item.label }}
          </div>
        </div>

        <div class="table-row table-header table-value">
          <div v-for="item in dailyHeader" :key="item.type" class="table-row">
            <div class="table-cell">최고</div>
            <div class="table-cell">최저</div>
            <div class="table-cell">
              <span v-if="$route.path == '/watt' && item.type=='watt'">합계</span>
              <span v-else>평균</span>
            </div>
          </div>
        </div>

        <div
          v-for="(data, index) in sortedData"
          :key="index"
          class="table-row"
        >
          <div class="table-cell">{{ data.checkDate }}</div>
          <div v-for="item in dailyHeader" :key="item.type" class="table-row">
            <div class="table-cell">{{ data[`${item.type}_highest`] || '-' }}</div>
            <div class="table-cell">{{ data[`${item.type}_lowest`] || '-' }}</div>
            <div class="table-cell bg-color font-weight">{{ data[`${item.type}_average`] || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </v-container>

  <v-container v-else>
    <div class="mb-table">
      <div 
        class="value-group" 
        v-for="(data, index) in formattedData" 
        :key="index"
      >
        <div class="timetable-hd">
          <div>날짜</div>
          <div>{{ data.checkDate }}</div>
        </div>

        <!-- 각 데이터 항목 (온도, 습도 등) -->
        <div 
          class="daily-table-row" 
          v-for="item in dailyHeader" 
          :key="item.type" 
        >
          <div class="label">{{ item.label }}</div>
          
          <!-- 최고, 최저, 평균 데이터 -->
          <div class="value_flex mt-1">
            <div class="value-group-daily">
              <div class="daily-text red-text">최고</div>
              <div class="red-text">{{ data[`${item.type}_highest`] || '-' }}</div>
            </div>
            <div class="value-group-daily">
              <div class="daily-text blue-text">최저</div>
              <div class="blue-text">{{ data[`${item.type}_lowest`] || '-' }}</div>
            </div>
            <div class="value-group-daily">
              <div class="daily-text">
                <span v-if="$route.path == '/watt' && item.type=='watt'">합계</span>
                <span v-else>평균</span>
              </div>
              <div style="font-weight:500;">{{ data[`${item.type}_average`] || '-' }}</div>
            </div>
          </div>

          <div class="line-table"></div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    listData_daily: {
      type: Array,
      required: true,
    },
    dailyHeader: {  
      type: Array,
      required: true,
    },
    loadingTable: Boolean,
  },
  computed: {
    sortedData() {
      return [...this.listData_daily].map(data => {
        const formatted = { checkDate: data.checkDate };
        this.dailyHeader.forEach(item => {
          formatted[`${item.type}_highest`] = data[`${item.type}_highest`] || '-';
          formatted[`${item.type}_lowest`] = data[`${item.type}_lowest`] || '-';
          formatted[`${item.type}_average`] = data[`${item.type}_average`] || '-';
        });
        return formatted;
      }).sort((a, b) => this.Sortable 
        ? new Date(a.checkDate) - new Date(b.checkDate) 
        : new Date(b.checkDate) - new Date(a.checkDate)
      );
    },
    // formattedData() {
    //   return this.listData_daily.map(data => {
    //     const formatted = { checkDate: data.checkDate };
    //     this.dailyHeader.forEach(item => {  // dailyHeader로 변경
    //       formatted[`${item.type}_highest`] = data[`${item.type}_highest`] || '-';
    //       formatted[`${item.type}_lowest`] = data[`${item.type}_lowest`] || '-';
    //       formatted[`${item.type}_average`] = data[`${item.type}_average`] || '-';
    //     });
    //     return formatted;
    //   });
    // },
    
    gridTemplateColumns() {
      // 날짜 열(10vw) + 항목별로 3개의 열씩
      return `10vw repeat(${this.dailyHeader.length * 3}, minmax(80px, 1fr))`;
    },
  },
  data(){
    return{
      isMobile: window.innerWidth < 769,
      Sortable: false,
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },
    sortByDate(){
      this.Sortable = !this.Sortable;
      this.sortedData.sort((a, b) => {
        return this.Sortable 
          ? new Date(a.checkDate) - new Date(b.checkDate) 
          : new Date(b.checkDate) - new Date(a.checkDate);
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../style/timetable_mb.scss';

.table-container{
  height:70vh;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  overflow-y: auto;
  border-radius: 20px;
  border: 0;
}
.skeleton {
  background-color: #f0f0f0;
  height: 30px;
  width: 100%;
  border-radius: 20px;
  animation: skeleton-loading 1s linear infinite alternate;
}

@keyframes skeleton-loading {
  0% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}
.table-gird {
  display: grid;
  grid-template-columns: v-bind('gridTemplateColumns');
  gap: 1px;
  border: 0;
}

.table-row {
  display: contents;
}

.table-cell {
  padding: 5px;
  border:0;
  text-align: center;
  background-color: #fff;
}

.date-cell {
  font-weight: bold;
  background-color: #f7f9fc;
}

.table-header .table-cell {
  position: sticky;
  top: 0; 
  font-weight: bold;
  background-color: #005B96;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
// .table-value{
//   position: sticky;
//   top: 5;
//   z-index:1;
// }
.date{
  cursor: pointer;
}
.sub-header .table-cell {
  font-weight: bold;
  background-color: #e6f2ff;
}

.bg-color {
  background-color: #E7EDFD;
}
.font-weight{
  font-weight:600;
}
table {
  width: 100%;
  table-layout: fixed; 
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;
}

thead {
  position: sticky;
  top: 0;
  background-color: #005B96;
  color: white;
  z-index: 1;
}
thead th {
  padding: 10px;
}

tbody td {
  padding: 5px;
  border: 1px solid #ddd;
  background-color: white;
}
.timetable-hd{
  display:flex;
  justify-content: space-between;
  background-color: #005B96 !important;
  padding:5px;
  border-radius: 10px;
  font-weight:550;
  color:white !important;
}
</style>
